import { DisciplineGender } from "../matches/disciplines";
export const genderMale = 'M';
export const genderFemale = 'K';
export class PlayerHelper {
    static getPlayerGenderFromDisciplineGender(disciplineGender, matchPlayerIndex) {
        return disciplineGender === DisciplineGender.Mixed
            ? (matchPlayerIndex === 0 ? genderMale : genderFemale)
            : (disciplineGender === DisciplineGender.Men ? genderMale : genderFemale);
    }
}
